import { render, staticRenderFns } from "./AboutViewFfa.vue?vue&type=template&id=33a8cec8"
import script from "./AboutViewFfa.vue?vue&type=script&lang=js"
export * from "./AboutViewFfa.vue?vue&type=script&lang=js"
import style0 from "./AboutViewFfa.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports